const className = 'discount';

const isAvailable = ({discount}) => Boolean(discount);

const getProps = ({discount}) => discount;

export default {className, isAvailable, getProps};
